import React, { Component } from 'react'
import { FlexWrapper, Icon, DefaultText } from './'

class SearchSuggestion extends Component {
  state = {}
  render() {
    const { label, ...props } = this.props
    return (
      <FlexWrapper direction="row" alignItems="center" viewPadding="10px 0 0 0" {...props}>
        <Icon icon="suggestion" />{' '}
        <DefaultText color="#124b5f" padding="0 0 0 12px">
          {label}
        </DefaultText>
      </FlexWrapper>
    )
  }
}

export default SearchSuggestion



// WEBPACK FOOTER //
// ./src/components/SearchSuggestion.js